import { useInterestQuestionariesTemplateConfiguration } from "PFApp/hooks";
import { useInitialQuestionsValues } from "PFApp/hooks/activity_form/use_initial_questions_values";
import { useMemo } from "react";

import { useActivityFormStore } from "../activity_form_store";

export const useShowInterestQuestions = () => {
  const { isEdit, isClone } = useActivityFormStore((state) => state.activityStatus);
  const activity = useActivityFormStore((state) => state.activity);
  const template = useActivityFormStore((state) => state.template);
  const templateConfig = useInterestQuestionariesTemplateConfiguration(template);

  const { getInitialQuestionsValues } = useInitialQuestionsValues({ template });
  const { initialQuestionsValues } = getInitialQuestionsValues({
    inheritFromActivity: isEdit,
    isClone,
    activity
  });

  const isAtLeastOneQuestion = useMemo(
    () => initialQuestionsValues.some((value) => value.trim() !== ""),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (isEdit) {
    return isAtLeastOneQuestion;
  }

  if (isClone) {
    const areQuestionsProvidedInActivity = !!activity.metadata?.interest_questions;

    return areQuestionsProvidedInActivity;
  }

  return !!templateConfig?.showQuestions && (isAtLeastOneQuestion || !!templateConfig?.allowRmToEdit);
};
